module.exports = __webpack_public_path__ + "media/images/project/orange-plus-8e9c32a9618da5f09b8f6344fb9871ef.svg";